module.exports = __webpack_public_path__ + "img/cpzxIcon4.dec74c88.png";